import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] bg-white">
      <Seo
        noindex
        title="Page Not Found | MAG"
        description="The page you're looking for doesn't exist."
        path="/404"
      />
      <section className="relative overflow-hidden bg-gray-950 px-4 py-16 text-center text-white sm:py-20">
        <div className="absolute inset-0 bg-tech-grid opacity-30" aria-hidden="true" />
        <div className="relative">
        <h1 className="mb-4 text-3xl font-bold tracking-tight sm:text-5xl">Page Not Found</h1>
        <p className="mx-auto max-w-xl text-base text-white/75 sm:text-lg">
          The page you're looking for doesn't exist.
        </p>
        <Link
          to="/"
          className="btn-primary mt-8"
          discover="none"
        >
          Back to Home
        </Link>
        </div>
      </section>
    </div>
  );
}
